

const INITIAL_STATE = {
  user: null,
  models: [],
};

export default function firebaseReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_USER': {
      return { ...state, user: action.payload };
    }
    case 'CLEAR_USER': {
      return { ...state, user: null };
    }
    default:
      return state;
  }
}

